import { render, staticRenderFns } from "./PollCardButtons.vue?vue&type=template&id=81830e60&"
import script from "./PollCardButtons.vue?vue&type=script&lang=ts&"
export * from "./PollCardButtons.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports